export default "/assets/images/mila-feed-04-thumbnail.7b58e585f8844fb3.jpg";